export interface ICssBlock {
	properties: ICssProperty[];
}

export interface ICssProperty {
	property: string;
	value: string;
	important?: string;
}

export class CssPropertyProvider {

	public static fromProperties(...props: ICssProperty[]): object {
		let retval = {};

		for(const prop of props) {
			if(prop) {
				retval = {...retval, [prop.property]: prop.value};
			}
		}

		return retval;
	}

	public static fromBlocks(...blocks: ICssBlock[]) {
		return {};
	}
}



// WEBPACK FOOTER //
// ./src/common/theme/CssPropertyProvider.ts